import { PageSubTitle, PageTitle } from "@/components/pageTitle";

export const GlobalNetwork = () => {
  return (
    <div className="flex justify-center ">
      <div className="px-[150px] pb-[80px] pt-[100px] w-[1920px]">
        <PageTitle title="光年KWAN加速引擎 组建全球加速网络" />
        <PageSubTitle title="采用全自研SD-WAN组网方案，可以在任何地点就近接入用户、接入设备、接入线路" />
        <img src="/imgs/kwan/global.png" className="w-[100%] mt-[140px]" />
      </div>
    </div>
  );
};
